import React from "react";
import { ReferralModal } from "./referralModal";

const ReferralModalTSB = () => {
  const { Title, Text, CloseButton } = ReferralModal;
  return (
    <ReferralModal referralType="tsb">
      <Title>Hey The Salon Business friend!  👋</Title>
      <Text>
        Hi from Mangomint! We're built for teams with 2+ providers — if that's you, take a look around and start a trial
        when you're ready. You'll get 1 month free if you decide it's the right fit.
      </Text>
      <CloseButton>Sounds good!</CloseButton>
    </ReferralModal>
  );
};

export { ReferralModalTSB };
